import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { HttpModule, Http } from '@angular/http';
import { RouterModule, Routes } from '@angular/router';
import { MaterialModule } from '@angular/material';
import { FlexLayoutModule } from "@angular/flex-layout";
import { Angulartics2Module, Angulartics2GoogleAnalytics } from 'angulartics2';


import { AccordionModule } from 'primeng/primeng';
import { CarouselModule } from 'angular2-carousel-ztw/carousel.module';
import { CookieModule } from 'ngx-cookie';
import { TranslateModule, TranslateLoader } from "@ngx-translate/core";
import { TranslateHttpLoader } from "@ngx-translate/http-loader";

import { AppComponent } from './app.component';
import { NavbarComponent } from './navbar/navbar.component';
import { MainComponent } from './main/main.component';
import { AboutComponent } from './about/about.component';
import { TeamComponent } from './team/team.component';
import { TestsComponent } from './tests/tests.component';
import { NewsComponent } from './news/news.component';
import { DirectoryComponent } from './directory/directory.component';
import { ContactComponent } from './contact/contact.component';
import { DoctorOscarComponent } from './team/doctor-oscar/doctor-oscar.component';
import { DoctoraAliciaComponent } from './team/doctora-alicia/doctora-alicia.component';
import { DoctorJoseComponent } from './team/doctor-jose/doctor-jose.component';
import { DoctorHoracioComponent } from './team/doctor-horacio/doctor-horacio.component';
import { FooterComponent } from './footer/footer.component';
import { SoonComponent } from './soon/soon.component';
import { ContactService } from './contact/contact.service';


const appRoutes: Routes = [
  { path: '', component: MainComponent },
  { path: 'about', component: AboutComponent },
  { path: 'team', component: TeamComponent },
  { path: 'team/doctor-horacio', component: DoctorHoracioComponent },
  { path: 'team/doctor-oscar', component: DoctorOscarComponent },
  { path: 'team/doctora-alicia', component: DoctoraAliciaComponent },
  { path: 'team/doctor-jose', component: DoctorJoseComponent },
  { path: 'tests', component: TestsComponent},
  { path: 'news', component: NewsComponent},
  { path: 'directory', component: DirectoryComponent},
  { path: 'contact', component: ContactComponent},
  { path: '', redirectTo: '', pathMatch: 'full'},
  // { path: '**', component: PageNotFoundComponent }
];

// AoT requires an exported function for factories
export function HttpLoaderFactory(http: Http) {
    return new TranslateHttpLoader(http);
}

@NgModule({
  declarations: [
    AppComponent,
    NavbarComponent,
    MainComponent,
    AboutComponent,
    TeamComponent,
    TestsComponent,
    NewsComponent,
    DirectoryComponent,
    ContactComponent,
    DoctorOscarComponent,
    DoctoraAliciaComponent,
    DoctorJoseComponent,
    DoctorHoracioComponent,
    FooterComponent,
    SoonComponent
  ],
  imports: [
    RouterModule.forRoot(appRoutes),
    BrowserModule,
    FormsModule,
    HttpModule,
    BrowserAnimationsModule,
    MaterialModule,
    FlexLayoutModule,
    CarouselModule,
    Angulartics2Module.forRoot([ Angulartics2GoogleAnalytics ]),
    AccordionModule,
    CookieModule.forRoot(),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [Http]
      }
    }),
    ReactiveFormsModule
  ],
  providers: [ContactService],
  bootstrap: [AppComponent]
})
export class AppModule { }



// WEBPACK FOOTER //
// ./src/app/app.module.ts